import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-248" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-249" data-mp="3fxb22ggddmb4">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-250" data-mp="3azjcht376ca3">
          Testimonials from educators using this teacher ready
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-251" data-mp="31zd2wiamdwg7">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-slate-300/20 bg-blue-950/60 p-6 shadow-lg shadow-black/20" data-id="element-252" data-mp="2x1kzar0m4lw6" data-mpi={index}>
              <div className="flex text-slate-300" aria-label="5 out of 5 stars" data-id="element-253" data-mp="h816vm00ecjf">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-254" data-mp="78a9nck2djfn" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-slate-300" data-id="element-255" data-mp="c7n0e8e23ani">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-slate-300/20 pt-4" data-id="element-256" data-mp="zwy33veyvf4a">
                <span className="metal-silver flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-sm font-extrabold text-blue-950" data-id="element-257" data-mp="14u7rd7qmdkqj">
                  {initials}
                </span>
                <span data-id="element-258" data-mp="v44xl5boc2r5">
                  <b className="block text-sm text-white" data-id="element-259" data-mp="v3mqfdnh444g">{name}</b>
                  <small className="text-xs text-slate-400" data-id="element-260" data-mp="1iuihg8k3uvan">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}